import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders, API, buildError } from '../../api/apis';
import { ApiResponse, CreateLinkAccountRequest, CreateLinkAccountResponse, ListLinkAccountRequest, ListXAccountRequest } from '../../interfaces/interfaces';

export const accountsService = createApi({
  reducerPath: 'accountsApi',
  tagTypes: ['Accounts'],
  baseQuery: fetchBaseQuery({
    prepareHeaders: (headers, { getState, endpoint }) => {
      // Skip if already set by the mutation call
      if (endpoint === 'createLinkAccount') {
        return headers;
      }
      return prepareHeaders(headers);
    },
  }),
  endpoints: (builder) => ({
    getLinkAccounts: builder.query({
        query: (requestFirewallDetails: ListLinkAccountRequest | undefined) => {
            const result = API.FETCH_LINK_ACCOUNTS(requestFirewallDetails);
            return result || ''; // Ensure a valid string is returned
        },
        providesTags: () => [{ type: 'Accounts', id: 'LIST' }],
        transformResponse: (
          response: Array<Record<string, string>>,
          meta,
          requestFirewallDetails
        ) => {
          const accounts = response?.Response?.AccountDetails || [];
          const items = (accounts && requestFirewallDetails?.onboarded)
            ? accounts.filter((account) => account?.OnboardingStatus === "Success")
              .map((account) => account?.AccountId)
            : accounts;
          return {
            items: items,
            serviceAccount: response?.Response?.AccountDetails[0]?.ServiceAccountId || undefined,
            mpRegion: response?.Response?.MpRegion || undefined,
            nexttoken: response?.Response?.NextToken || undefined,
          }
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
    getXAccountsDetails: builder.query({
      query: (requestFirewallDetails: ListXAccountRequest | undefined) => {
          const result = API.FETCH_XACCOUNT_ROLES_DETAILS(requestFirewallDetails);
          return result || ''; // Ensure a valid string is returned
      },
    transformResponse: (response: any) => {
      return {
        items: response.Response || {},
        nexttoken: response?.Response?.NextToken || undefined,
      }
    },
    transformErrorResponse: (response) => {
      return buildError(response, "");
    },
    }),
    createLinkAccount: builder.mutation({
      query: ({ payload, headers }: { payload: CreateLinkAccountRequest, headers?: HeadersInit }) => ({
        url: `${API.CREATE_LINK_ACCOUNT(payload)}`,
        method: 'POST',
        body: payload,
        headers,
      }),
      invalidatesTags: () => [{ type: 'Accounts', id: 'LIST' }],
      transformResponse: (response: ApiResponse) => {
        return response.Response as CreateLinkAccountResponse;
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetLinkAccountsQuery, useGetXAccountsDetailsQuery, useCreateLinkAccountMutation } = accountsService;
